import React, { useRef } from 'react';
import clsx from 'classnames';
import './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import QueueAnim from 'rc-queue-anim';

const Banner = () => {
  const swiperInstance = useRef(null);
  const swiperRef = useRef(null);

  const certificateList = [
    {
      title: '高新技术企业证书',
      imgUrl: '/images/certificate1.png',
    },
    {
      title: '浙江省创新性中小企业证书',
      imgUrl: '/images/certificate2.png',
    },
    {
      title: 'CMA资质认定证书',
      imgUrl: '/images/certificate3.png',
    },
    {
      title: 'CNAS证书',
      imgUrl: '/images/certificate4.png',
    },
  ];

  // 专利软著
  const softCertificateList = [
    { imgUrl: '/images/certificate5.png' },
    { imgUrl: '/images/certificate6.png' },
    { imgUrl: '/images/certificate7.png' },
    { imgUrl: '/images/certificate8.png' },
    { imgUrl: '/images/certificate9.png' },
    { imgUrl: '/images/certificate10.png' },
    { imgUrl: '/images/certificate11.png' },
    { imgUrl: '/images/certificate12.png' },
    { imgUrl: '/images/certificate13.png' },
    { imgUrl: '/images/certificate14.png' },
    { imgUrl: '/images/certificate15.png' },
    { imgUrl: '/images/certificate16.png' },
    { imgUrl: '/images/certificate17.png' },
    { imgUrl: '/images/certificate18.png' },
    { imgUrl: '/images/certificate19.png' },
    { imgUrl: '/images/certificate20.png' },
    { imgUrl: '/images/certificate21.png' },
  ];

  const onPrev = () => {
    if (swiperInstance.current) {
      swiperInstance.current.slidePrev();
    }
  };

  const onNext = () => {
    if (swiperInstance.current) {
      swiperInstance.current.slideNext();
    }
  };

  // const onCertPrev = () => {
  //   if (swiperRef.current) {
  //     swiperRef.current.slidePrev();
  //   }
  // };

  // const onCertNext = () => {
  //   if (swiperRef.current) {
  //     swiperRef.current.slideNext();
  //   }
  // };

  const certificateBreakpoints = {
    // 小屏幕（手机）
    690: {
      slidesPerView: 1,
    },
    // 中等屏幕（平板）
    768: {
      slidesPerView: 2,
    },
    // 大屏幕（桌面）
    1250: {
      slidesPerView: 2,
    },
    1395: {
      slidesPerView: 3,
    },
    1530: {
      slidesPerView: 4,
    },
  };

  const breakpoints = {
    // 小屏幕（手机）
    690: {
      slidesPerView: 1,
    },
    // 中等屏幕（平板）
    768: {
      slidesPerView: 2,
    },
    // 大屏幕（桌面）
    1224: {
      slidesPerView: 3,
    },
    1395: {
      slidesPerView: 3,
    },
    1530: {
      slidesPerView: 4,
    },
  };

  return (
    <div className={clsx('certificate-banner')}>
      <div className={clsx('certificate-banner-mask')} />
      <QueueAnim
        className={clsx('certificate-banner-content')}
        type={['top', 'bottom']}
      >
        <div
          className={clsx('certificate-banner-content-title')}
          key='certificate-banner-content-title'
        >
          多项资质权威认证 安全可信
        </div>
        <div
          className={clsx('certificate-banner-content-text')}
          key='certificate-banner-content-text1'
        >
          资质证书
        </div>
        <div
          className={clsx('certificate-banner-content-certificateList')}
          key='certificate-banner-content-certificateList'
        >
          {/* <div
            className={clsx('certificate-banner-content-softList-prev')}
            onClick={onCertPrev}
          >
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M15 19L8 12L15 5'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div> */}
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation={false}
            autoplay={true}
            loop={true}
            pagination={false}
            breakpoints={certificateBreakpoints}
            // onSwiper={(swiper) => {
            //   swiperRef.current = swiper;
            // }}
            delay={100}
          >
            {certificateList.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className={clsx(
                    'certificate-banner-content-certificateList-item',
                  )}
                >
                  <img src={item.imgUrl} alt={item.title} width={'90%'} />
                  <div
                    className={clsx(
                      'certificate-banner-content-certificateList-item-text',
                    )}
                  >
                    {item.title}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* <div
            className={clsx('certificate-banner-content-softList-next')}
            onClick={onCertNext}
          >
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M9 5L16 12L9 19'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div> */}
        </div>
        <div
          className={clsx('certificate-banner-content-text')}
          key='certificate-banner-content-text2'
        >
          专利软著
        </div>
        <div
          className={clsx('certificate-banner-content-desc')}
          key='certificate-banner-content-desc'
        >
          多项自主研发专利，直达市场需求
        </div>
        {/* 专利软著轮播 */}
        <div
          className={clsx('certificate-banner-content-softList')}
          key='certificate-banner-content-softList'
        >
          <div
            className={clsx('certificate-banner-content-softList-prev')}
            onClick={onPrev}
          >
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M15 19L8 12L15 5'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation={false}
            autoplay={false}
            loop={true}
            pagination={false}
            breakpoints={breakpoints}
            onSwiper={(swiper) => {
              swiperInstance.current = swiper;
            }}
          >
            {softCertificateList.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className={clsx('certificate-banner-content-softList-item')}
                >
                  <img src={item.imgUrl} alt={item.title} width={'90%'} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className={clsx('certificate-banner-content-softList-next')}
            onClick={onNext}
          >
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M9 5L16 12L9 19'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </div>
      </QueueAnim>
    </div>
  );
};

export default Banner;
